import ListTableMainCell from '../../../components/list-table-main-cell/list-table-main-cell.component';
import { displayCellValue } from '../../../utils/column-values.util';

export const HELP_CATEGORIES_COLUMNS = [
    {
        Header: "Label",
        accessor: "label",
        style: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 2
        },
        Cell: ({ value, row }) => {
            const uuid = row.original.uuid;
            return (
                <ListTableMainCell
                    value={value}
                    uuid={uuid}
                />
            )
        }
    },
    {
        Header: "Icon",
        accessor: "iconKey",
        Cell: ({ value }) => displayCellValue(value)
    },
    {
        Header: "Sort Order",
        accessor: "sortOrder",
        Cell: ({ value }) => displayCellValue(value)
    },
]
